module.exports = __webpack_public_path__ + "img/card-sample.32a2edce.svg";